import { AlertInfo } from "src/@/components/shared/AlertInfo";

const CardEnableBot = ({
  changeBlock,
  block,
}) => {

  return (
    <div className="w-full">
      <div className="space-y-4">
        <div>
          <AlertInfo
            title="Reabilitar Bot"
            description="Se houver um chat vinculado, o bot será reabilitado (silenciamento removido) e voltará a responder pela IA."
          />
        </div>
      </div>
    </div>
  );
};

export default CardEnableBot;
